<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="ajouterPa()">Ajouter un Document PA</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="export()">Exporter</button>
	</div>
</nav>

<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

	<table mat-table matSort [dataSource]="dataSource" class="liste-pas">

		<ng-container matColumnDef="id">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
		<td mat-cell *matCellDef="let pa"><a href="#"
			title="Voir le détail de ce PA" (click)="showPaResume(pa)">{{ pa.id }}</a></td>
		</ng-container>

		<ng-container matColumnDef="numeroPa">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Numéro</th>
		<td mat-cell *matCellDef="let pa"><a href="#"
			title="Voir le détail de ce PA" (click)="showPaResume(pa)">{{ pa.numeroPa }}</a></td>
		</ng-container>

		<ng-container matColumnDef="parcs">
		  <th mat-header-cell *matHeaderCellDef mat-sort-header>Parcs</th>
		  <td mat-cell *matCellDef="let pa"
		      title="{{ pa.parcDescription }}"
		      [ngClass]="{
		        'etat-signe': pa.etat === 'SIGNE',
		        'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT',
		        'etat-archive': pa.obsolete
		      }">
		    {{ pa.parcDescription | truncate:[18, '...'] }}
		  </td>
		</ng-container>
		
		<ng-container matColumnDef="entreprises">
		  <th mat-header-cell *matHeaderCellDef mat-sort-header>
		    Entreprises
		  </th>
		  <td mat-cell *matCellDef="let pa"
		      title="{{ pa.nomEntreprises }}"
		      [ngClass]="{
		        'etat-signe': pa.etat === 'SIGNE',
		        'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT',
		        'etat-archive': pa.obsolete
		      }">
		    {{ pa.nomEntreprises | truncate:[20, '...'] }}
		  </td>
		</ng-container>
		
		<ng-container matColumnDef="description">
		  <th mat-header-cell *matHeaderCellDef mat-sort-header>
		    Description
		  </th>
		  <td mat-cell *matCellDef="let pa"
		      title="{{ pa.description }}"
		      [ngClass]="{
		        'etat-signe': pa.etat === 'SIGNE',
		        'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT',
		        'etat-archive': pa.obsolete
		      }">
		    {{ pa.description | truncate:[20, '...'] }}
		  </td>
		</ng-container>

		<ng-container matColumnDef="etat">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Etat</th>
		<td mat-cell *matCellDef="let pa"
		    [ngClass]="{ 'etat-signe': pa.etat === 'SIGNE', 'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT', 'etat-archive': pa.obsolete }">
		  	{{ pa | libelleEtatPa }}
		</td>
		</ng-container>

		<ng-container matColumnDef="dateDebut">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de
			début</th>
		<td mat-cell *matCellDef="let pa" [ngClass]="{ 'etat-signe': pa.etat === 'SIGNE', 'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT', 'etat-archive': pa.obsolete }">{{ pa.dateDebut |
			displayLocalDate }}</td>
		</ng-container>

		<ng-container matColumnDef="dateFin">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de fin
		</th>
		<td mat-cell *matCellDef="let pa" [ngClass]="{ 'etat-signe': pa.etat === 'SIGNE', 'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT', 'etat-archive': pa.obsolete }">{{ pa.dateFin |
			displayLocalDate }}</td>
		</ng-container>

		<ng-container matColumnDef="validite">
		  <th mat-header-cell *matHeaderCellDef mat-sort-header>Validité</th>
		  <td mat-cell *matCellDef="let pa"
		      [ngClass]="{
		        'etat-signe': pa.etat === 'SIGNE',
		        'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT',
		        'etat-archive': pa.obsolete
		      }">
		    {{ pa | libelleValiditePa }}
		  </td>
		</ng-container>
		
		<ng-container matColumnDef="joursAvantExpiration">
		  <th mat-header-cell *matHeaderCellDef mat-sort-header>
		    Jours avant expiration
		  </th>
		  <td mat-cell *matCellDef="let pa"
		      class="numberOfDaysRemaining"
		      [ngClass]="{
		        'etat-signe': pa.etat === 'SIGNE',
		        'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT',
		        'etat-archive': pa.obsolete
		      }">
		    {{ pa.dateFin | displayNbJoursAvantExpiration }}
		  </td>
		</ng-container>

		<ng-container matColumnDef="lien">
		<th mat-header-cell *matHeaderCellDef>Lien</th>
		<td mat-cell *matCellDef="let pa"><a alt="Télécharger"
			title="Télécharger" target="_blank"
			href="{{ pa.lien ? pa.lien : '#' }}" *ngIf="pa.lien"> <i
				class="fa fa-link"></i>
		</a></td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
	
			<td mat-cell *matCellDef="let pa" class="actions">
			
				<a href="#" title="Signer" (click)="openSignatairesDialog(pa); $event.preventDefault()" *ngIf="pa.parcActif && pa.etat !== 'BROUILLON'">
				  <i class="fa-regular fa-circle-check fa-lg" [ngClass]="{ 'etat-signe': pa.etat === 'SIGNE', 'etat-signe-partiel': pa.etat === 'SIGNE_PARTIELLEMENT' }"> </i>
				</a>
				
				<a href="#" title="Gérer les intervenants" class= "intervenants" (click)="openDialogForIntervenants(pa)" *ngIf="pa.parcActif " >
					<i class="fa fa-user fa-lg"></i>
				</a>
				
				<a href="#" title="Ajouter un lien" *ngIf="pa.parcActif" class= "lien" (click)="openDialogForPaLink(pa)">
					<i class="fa fa-paperclip fa-lg"></i>
				</a>
				
				<a href="#" title="Générer le PDF" *ngIf="pa.parcActif && pa.etat !== 'BROUILLON'" class="genererPdf" (click)="openDialogForGeneration(pa.id)"> 
					<i class="fa fa-download fa-lg"></i>
				</a> 
				
				<a href="#" (click)="modifierPa(pa)" title="{{ pa | actionTitleForPa:['Modifier'] }}" class="modifier" *ngIf="pa.parcActif"> 
					<i class="fa-regular fa-pen-to-square fa-lg"></i>
				</a>
				
				<a href="#" title="{{ pa | actionTitleForPdp:['Dupliquer'] }}" (click)="dupliquerPa(pa)" *ngIf="pa.parcActif" >
					<i class="fa-regular fa-copy fa-lg"></i>
				</a>
				
				<a href="#" title="Archiver" class="archiver" (click)="archiver(pa)" *ngIf="pa.parcActif" >
					<i class="fa fa-archive fa-lg"></i>
				</a>
				
				<a href="#" title="Supprimer" class="supprimer" (click)="supprimer(pa)" *ngIf="pa.parcActif " >
					<i class="fa fa-trash fa-lg"></i>
				</a>
			
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

	</table>

	<mat-paginator #paginator showFirstLastButtons
		[pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="10"
		aria-label="Choisissez une page"> </mat-paginator>
</div>

<pa-resume [id]="'paResumeDialog'" [detailCommands]="resumeDialogCommands" [etatCommands]="resumeEtat"></pa-resume>
<pa-generation [id]="'paGenerationDialog'" [generationCommands]="generationCommands"></pa-generation>
<pa-manage-link [id]="'paManageLinkDialog'" [manageCommands]="manageLinkCommands" (paChanged)="onPaLinkChanged($event)"></pa-manage-link>
<gestion-signature-pa [id]="'signatairesPaSpecificDialog'" [signCommands]="dialogSignatairesPaCommands" (paChanged)="onPaSignatureChanged($event)"></gestion-signature-pa>
<pa-manage-intervenants [id]="'paIntervenantsDialog'" [intervenantCommands]="manageIntervenantsCommands"></pa-manage-intervenants>